export const LIMIT_OF_TRANSACTIONS = 100000;

export const LIMIT_OF_ONGOING_TRANSACTIONS = 5;

export const REPORT_STATUS = {
  REQUESTED: "REQUESTED",
  IN_PROGRESS: "IN_PROGRESS",
  FINISHED: "FINISHED",
  FAILURE: "FAILURE",
} as const;
